import type { Anime } from "@/types";

export const animeList: Anime[] = [
  {
    id: "anime-1",
    title: "星海启航 Starsea Voyage",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20poster%20illustration%20of%20a%20young%20space%20explorer%20standing%20on%20a%20deck%20gazing%20at%20a%20vast%20colorful%20nebula%2C%20vibrant%20orange%20and%20teal%20sky%2C%20clean%20minimal%20background%2C%20modern%20japanese%20animation%20style%2C%20high%20detail%2C%20illustrative%20poster&width=400&height=560&seq=anime-cover-01&orientation=portrait",
    description:
      "少年跟随古老星图踏上星际远航，在浩瀚宇宙中寻找失落文明的踪迹。",
    rating: 9.2,
    genre: ["科幻", "冒险", "热血"],
    year: "2025",
    region: "日本",
    episodes: 24,
    status: "连载中",
    cast: [
      { actor: "林泽言", role: "配音 星野遥" },
      { actor: "苏晴", role: "配音 莉亚" },
      { actor: "陈默", role: "配音 船长老葛" },
    ],
    synopsis:
      "在一个星际航行已成常态的时代，来自边缘星球的少年星野遥偶然获得一张古老星图。为了解开星图背后的谜题，他登上破旧的探险船“风信子号”，与倔强的机械师莉亚、沉默的船长老葛一同穿越危险的小行星带与坍缩星域。旅途中他逐渐发现，星图指向的不仅是失落的文明，更关乎整个星系的命运。",
    tags: ["星际", "探险", "成长"],
    views: 128000,
    publishTime: "2025-09-18",
  },
  {
    id: "anime-2",
    title: "苍穹之翼 Skywing Chronicles",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20poster%20of%20a%20female%20knight%20with%20large%20feathered%20wings%20flying%20above%20floating%20islands%2C%20warm%20sunset%20oranges%20and%20soft%20clouds%2C%20clean%20minimal%20sky%20background%2C%20modern%20fantasy%20anime%20illustration%2C%20high%20detail&width=400&height=560&seq=anime-cover-02&orientation=portrait",
    description:
      "拥有羽翼的少女骑士在浮空群岛间守护最后的天空之城。",
    rating: 8.9,
    genre: ["奇幻", "冒险", "战斗"],
    year: "2025",
    region: "日本",
    episodes: 12,
    status: "已完结",
    cast: [
      { actor: "顾南音", role: "配音 艾莉娅" },
      { actor: "周时叙", role: "配音 凯尔文" },
    ],
    synopsis:
      "天空历三千年，浮空群岛之间靠风桥相连。少女艾莉娅是最后一代“苍穹骑士”，背负着守护天空之城的使命。当沉寂百年的风暴再次逼近，她必须在天真与责任的抉择中，学会真正展开自己的羽翼。",
    tags: ["空战", "少女骑士", "史诗"],
    views: 96000,
    publishTime: "2025-07-02",
  },
  {
    id: "anime-3",
    title: "机械之心 Heart of Machine",
    cover:
      "https://readdy.ai/api/search-image?query=sci-fi%20anime%20poster%20of%20a%20humanoid%20robot%20child%20holding%20a%20glowing%20orange%20heart%20core%20in%20a%20neon%20industrial%20city%2C%20clean%20minimal%20background%2C%20cinematic%20lighting%2C%20modern%20anime%20illustration%2C%20high%20detail&width=400&height=560&seq=anime-cover-03&orientation=portrait",
    description:
      "一台被遗弃的仿生机器人，在废土城市里寻找“心”的意义。",
    rating: 9.0,
    genre: ["科幻", "治愈", "机战"],
    year: "2024",
    region: "中国",
    episodes: 16,
    status: "已完结",
    cast: [
      { actor: "许澄", role: "配音 编号 R-07" },
      { actor: "沈亦白", role: "配音 工程师阿哲" },
    ],
    synopsis:
      "在被沙尘覆盖的旧工业城市，退役工程师阿哲捡到一台还残留微弱能量的仿生机器人 R-07。R-07 执着地想弄明白一个问题：如果记忆可以删除，那“心”还剩下什么？两人在废墟中修理旧机器，也慢慢修补着各自破碎的过往。",
    tags: ["废土", "机器人", "温情"],
    views: 87000,
    publishTime: "2024-11-20",
  },
  {
    id: "anime-4",
    title: "樱花剑姬 Sakura Blade",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20poster%20of%20a%20swordswoman%20in%20pink%20kimono%20among%20falling%20cherry%20blossoms%2C%20dynamic%20pose%20with%20a%20katana%2C%20warm%20pink%20and%20orange%20palette%2C%20clean%20minimal%20background%2C%20modern%20japanese%20anime%20illustration%2C%20high%20detail&width=400&height=560&seq=anime-cover-04&orientation=portrait",
    description:
      "江户风格的架空世界里，一名少女剑客以花为誓，追查灭门真相。",
    rating: 8.7,
    genre: ["热血", "古风", "战斗"],
    year: "2024",
    region: "日本",
    episodes: 24,
    status: "已完结",
    cast: [
      { actor: "叶知秋", role: "配音 樱庭千夏" },
      { actor: "顾南音", role: "配音 银发剑客" },
    ],
    synopsis:
      "樱庭一族在一夜之间被神秘武士灭门，唯有年幼的千夏在樱花树下幸存。十年后，她以“樱姬”之名踏上旅途，在追查真相的路上，逐渐理解剑气与仁心的真正含义。",
    tags: ["剑戟", "复仇", "古风"],
    views: 79000,
    publishTime: "2024-04-12",
  },
  {
    id: "anime-5",
    title: "时空旅人 Chrono Traveler",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20poster%20of%20a%20boy%20surrounded%20by%20floating%20glowing%20clock%20fragments%20and%20time%20portals%2C%20cool%20teal%20and%20orange%20contrast%2C%20clean%20minimal%20background%2C%20modern%20anime%20illustration%2C%20high%20detail&width=400&height=560&seq=anime-cover-05&orientation=portrait",
    description:
      "每次回到过去，都会失去一段记忆。少年仍执意救回那个人。",
    rating: 9.1,
    genre: ["科幻", "悬疑", "恋爱"],
    year: "2025",
    region: "日本",
    episodes: 13,
    status: "连载中",
    cast: [
      { actor: "周时叙", role: "配音 时野" },
      { actor: "苏晴", role: "配音 夏织" },
    ],
    synopsis:
      "高中生时野得到一块能回溯时间的旧怀表，代价是每使用一次就会遗忘一段与重要之人的回忆。为了阻止那场事故，他一次次回到那个夏天，却发现改变过去的同时，也在抹去彼此存在的证据。",
    tags: ["时空", "催泪", "悬疑"],
    views: 112000,
    publishTime: "2025-08-30",
  },
  {
    id: "anime-6",
    title: "喵星学园 Meow Star Academy",
    cover:
      "https://readdy.ai/api/search-image?query=cute%20anime%20poster%20of%20cat-eared%20students%20in%20a%20bright%20cheerful%20school%20campus%2C%20pastel%20orange%20and%20cream%20colors%2C%20clean%20minimal%20background%2C%20chibi%20comedy%20anime%20illustration%2C%20high%20detail&width=400&height=560&seq=anime-cover-06&orientation=portrait",
    description:
      "一所全是猫咪拟人学生的学园，日常搞笑又治愈的校园喜剧。",
    rating: 8.5,
    genre: ["日常", "喜剧", "治愈"],
    year: "2025",
    region: "日本",
    episodes: 12,
    status: "连载中",
    cast: [
      { actor: "许澄", role: "配音 小橘" },
      { actor: "叶知秋", role: "配音 布丁学姐" },
    ],
    synopsis:
      "喵星学园里，猫拟人学生们每天为毛线球社团、鱼干食堂和期末考试忙得团团转。新生小橘一心想成为最受欢迎的社团明星，却总是被慵懒的布丁学姐带着跑偏。轻松爆笑的校园日常，专治不开心。",
    tags: ["搞笑", "萌系", "校园"],
    views: 64000,
    publishTime: "2025-06-01",
  },
  {
    id: "anime-7",
    title: "暗夜侦探 Nightfall Detective",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20poster%20of%20a%20detective%20in%20a%20long%20coat%20under%20rainy%20neon%20city%20lights%2C%20moody%20dark%20background%20with%20warm%20orange%20accents%2C%20mystery%20noir%20anime%20illustration%2C%20high%20detail&width=400&height=560&seq=anime-cover-07&orientation=portrait",
    description:
      "雨夜都市的侦探组合，专解那些警方束手无策的悬案。",
    rating: 8.8,
    genre: ["悬疑", "推理", "都市"],
    year: "2024",
    region: "日本",
    episodes: 20,
    status: "已完结",
    cast: [
      { actor: "陈默", role: "配音 沈夜" },
      { actor: "顾南音", role: "配音 白鸦" },
    ],
    synopsis:
      "在永远下雨的雾港市，前刑警沈夜与神秘黑客白鸦组成地下侦探事务所。他们专接警方不敢碰的案子，每一桩悬案背后都指向城市深处那张看不见的网。",
    tags: ["推理", "悬疑", "都市"],
    views: 82000,
    publishTime: "2024-09-09",
  },
  {
    id: "anime-8",
    title: "龙脊传说 Dragon Spine",
    cover:
      "https://readdy.ai/api/search-image?query=epic%20fantasy%20anime%20poster%20of%20a%20warrior%20standing%20before%20a%20giant%20mountain%20shaped%20like%20a%20dragon%20spine%2C%20dramatic%20orange%20sky%2C%20clean%20minimal%20background%2C%20modern%20anime%20illustration%2C%20high%20detail&width=400&height=560&seq=anime-cover-08&orientation=portrait",
    description:
      "猎人少年背负部族命运，攀登传说中龙脊山的试炼之路。",
    rating: 8.6,
    genre: ["奇幻", "冒险", "热血"],
    year: "2023",
    region: "中国",
    episodes: 26,
    status: "已完结",
    cast: [
      { actor: "林泽言", role: "配音 岩川" },
      { actor: "沈亦白", role: "配音 长老祁" },
    ],
    synopsis:
      "龙脊山是大陆最高的屏障，传说山顶有能实现愿望的龙魂。为了让干涸的部族重获水源，猎人岩川踏上攀登龙脊的试炼。风雪、断崖与守护兽层层阻隔，真正的考验却是他内心的恐惧。",
    tags: ["奇幻", "成长", "国漫"],
    views: 71000,
    publishTime: "2023-12-15",
  },
  {
    id: "anime-9",
    title: "甜梦烘焙屋 Sweet Dream Bakery",
    cover:
      "https://readdy.ai/api/search-image?query=cozy%20anime%20poster%20of%20a%20smiling%20girl%20baker%20surrounded%20by%20cakes%20and%20pastries%20in%20a%20warm%20bakery%2C%20soft%20cream%20and%20peach%20colors%2C%20clean%20minimal%20background%2C%20healing%20anime%20illustration%2C%20high%20detail&width=400&height=560&seq=anime-cover-09&orientation=portrait",
    description:
      "深夜才营业的烘焙屋，只招待怀有心事的客人。",
    rating: 9.0,
    genre: ["治愈", "日常", "美食"],
    year: "2025",
    region: "日本",
    episodes: 12,
    status: "连载中",
    cast: [
      { actor: "苏晴", role: "配音 店长蔻蔻" },
      { actor: "许澄", role: "配音 学徒小麦" },
    ],
    synopsis:
      "城市角落有一家只在深夜亮灯的烘焙屋。店长蔻蔻相信，每道点心都能对上一位客人的心事。蜂蜜舒芙蕾安抚失眠的上班族，咸奶油蛋糕则送给刚失恋的女孩。甜味散去，故事却留下温度。",
    tags: ["治愈", "美食", "温情"],
    views: 68000,
    publishTime: "2025-05-10",
  },
  {
    id: "anime-10",
    title: "银翼骑士团 Silverwing Knights",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20poster%20of%20mecha%20knights%20in%20silver%20armor%20standing%20in%20formation%2C%20orange%20energy%20glow%2C%20clean%20minimal%20background%2C%20mecha%20sci-fi%20anime%20illustration%2C%20high%20detail&width=400&height=560&seq=anime-cover-10&orientation=portrait",
    description:
      "少年机师加入银翼骑士团，驾驶机甲守卫最后的防线。",
    rating: 8.4,
    genre: ["机战", "热血", "科幻"],
    year: "2024",
    region: "日本",
    episodes: 24,
    status: "已完结",
    cast: [
      { actor: "周时叙", role: "配音 拓真" },
      { actor: "叶知秋", role: "配音 队长凛" },
    ],
    synopsis:
      "陨石带来的异兽不断逼近人类最后的堡垒。少年拓真通过了残酷的机师测试，加入传奇的银翼骑士团。在一次次生死战斗中，他明白了机甲不是武器，而是伙伴。",
    tags: ["机甲", "热血", "兄弟情"],
    views: 74000,
    publishTime: "2024-06-18",
  },
  {
    id: "anime-11",
    title: "灵狐物语 Spirit Fox Tale",
    cover:
      "https://readdy.ai/api/search-image?query=elegant%20fantasy%20anime%20poster%20of%20a%20white%20fox%20spirit%20girl%20in%20a%20shrine%20forest%20with%20floating%20lanterns%2C%20warm%20orange%20and%20green%20tones%2C%20clean%20minimal%20background%2C%20modern%20anime%20illustration%2C%20high%20detail&width=400&height=560&seq=anime-cover-11&orientation=portrait",
    description:
      "守林少女与化为人形的灵狐，共守一座即将消失的古神社。",
    rating: 8.9,
    genre: ["奇幻", "治愈", "恋爱"],
    year: "2025",
    region: "日本",
    episodes: 13,
    status: "连载中",
    cast: [
      { actor: "顾南音", role: "配音 千代" },
      { actor: "陈默", role: "配音 白狐" },
    ],
    synopsis:
      "随着村子日渐凋零，守护神社的工作只剩下少女千代一人。某个满月夜，一只受伤的白狐化作人形闯入她的生活。他们一起修补鸟居、点亮灯笼，也慢慢守住了这座神社存在的理由。",
    tags: ["神怪", "治愈", "和风"],
    views: 81000,
    publishTime: "2025-07-21",
  },
  {
    id: "anime-12",
    title: "赛博都市 2030 Cyber Metro 2030",
    cover:
      "https://readdy.ai/api/search-image?query=cyberpunk%20anime%20poster%20of%20a%20hacker%20girl%20on%20a%20rainy%20neon%20city%20street%20with%20holographic%20signs%2C%20orange%20and%20teal%20neon%20reflections%2C%20clean%20minimal%20background%2C%20modern%20anime%20illustration%2C%20high%20detail&width=400&height=560&seq=anime-cover-12&orientation=portrait",
    description:
      "在数据驱动的未来都市，一名黑客少女试图找回被删除的过去。",
    rating: 8.8,
    genre: ["赛博朋克", "科幻", "悬疑"],
    year: "2025",
    region: "欧美",
    episodes: 10,
    status: "已完结",
    cast: [
      { actor: "许澄", role: "配音 零号" },
      { actor: "沈亦白", role: "配音 网络警察" },
    ],
    synopsis:
      "2030 年的新港市，市民的记忆被云端统一管理。黑客少女代号“零”发现自己的档案有一整年被抹去，为查明真相，她潜入了这座城市最森严的数据核心。",
    tags: ["赛博朋克", "黑客", "未来"],
    views: 93000,
    publishTime: "2025-03-05",
  },
  {
    id: "anime-13",
    title: "海之守望者 Ocean Keeper",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20poster%20of%20a%20lighthouse%20keeper%20girl%20on%20a%20cliff%20facing%20a%20vast%20turquoise%20ocean%20at%20sunset%2C%20warm%20orange%20sky%2C%20clean%20minimal%20background%2C%20healing%20anime%20illustration%2C%20high%20detail&width=400&height=560&seq=anime-cover-13&orientation=portrait",
    description:
      "灯塔少女守着出海的约定，等待一艘永远不会靠岸的船。",
    rating: 8.7,
    genre: ["治愈", "剧情", "恋爱"],
    year: "2023",
    region: "日本",
    episodes: 12,
    status: "已完结",
    cast: [
      { actor: "苏晴", role: "配音 汐音" },
      { actor: "林泽言", role: "配音 航海士" },
    ],
    synopsis:
      "海岬上的灯塔是汐音唯一的家。她每天点亮灯火，为远航的船指引归途，也为了等一个十年前出海未归的人。直到一位年轻航海士的到来，让平静的海面重新泛起涟漪。",
    tags: ["海洋", "治愈", "等待"],
    views: 62000,
    publishTime: "2023-08-14",
  },
  {
    id: "anime-14",
    title: "幻境守护 Phantasm Guardians",
    cover:
      "https://readdy.ai/api/search-image?query=fantasy%20anime%20poster%20of%20two%20guardians%20with%20glowing%20magic%20shields%20in%20a%20dreamlike%20floating%20ruins%20realm%2C%20orange%20and%20violet%20magic%20glow%2C%20clean%20minimal%20background%2C%20modern%20anime%20illustration%2C%20high%20detail&width=400&height=560&seq=anime-cover-14&orientation=portrait",
    description:
      "梦境开始崩塌，两位守护者必须在幻境彻底消失前修复边界。",
    rating: 8.5,
    genre: ["奇幻", "冒险", "战斗"],
    year: "2025",
    region: "韩国",
    episodes: 16,
    status: "连载中",
    cast: [
      { actor: "周时叙", role: "配音 宇真" },
      { actor: "叶知秋", role: "配音 守护者茜" },
    ],
    synopsis:
      "人们的梦境汇聚成一片共享幻境。当一处裂痕开始吞噬整片梦境，守护者宇真与茜必须深入崩塌的梦之废墟，用记忆碎片重新织补边界，而代价是失去自己最珍贵的梦。",
    tags: ["梦境", "奇幻", "双主角"],
    views: 58000,
    publishTime: "2025-04-26",
  },
  {
    id: "anime-15",
    title: "沙罗双树 Sala Twin Trees",
    cover:
      "https://readdy.ai/api/search-image?query=philosophical%20anime%20poster%20of%20two%20identical%20trees%20under%20a%20fiery%20orange%20sky%20with%20a%20solitary%20figure%20between%20them%2C%20clean%20minimal%20background%2C%20artistic%20anime%20illustration%2C%20high%20detail&width=400&height=560&seq=anime-cover-15&orientation=portrait",
    description:
      "当同一个灵魂被分成两半，他们要如何面对彼此与命运。",
    rating: 9.1,
    genre: ["剧情", "奇幻", "悬疑"],
    year: "2024",
    region: "中国",
    episodes: 12,
    status: "已完结",
    cast: [
      { actor: "陈默", role: "配音 阿树" },
      { actor: "顾南音", role: "配音 阿罗" },
    ],
    synopsis:
      "一场古老的仪式将同一个灵魂分作两半，分别长成了阿树与阿罗。他们在不知情中彼此靠近又互相排斥，直到真相揭开的那一刻，才明白对方一直握着自己缺失的那部分人生。",
    tags: ["双生", "哲理", "剧情"],
    views: 85000,
    publishTime: "2024-10-30",
  },
];